// ...existing code...
export { databaseId, env };

import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';

const redirectURL = process.env.REACT_APP_FRONTEND_URL + "/magic";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Determine environment (use only REACT_APP_ENV)
const env = process.env.REACT_APP_ENV;
let databaseId = '(default)';
if (typeof window !== 'undefined') {
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1' || host.endsWith('.localhost')) {
    databaseId = 'development';
  }
} else if (env === 'development' || env === 'dev') {
  databaseId = 'development';
} else if (env === 'test' || env === 'testing') {
  databaseId = 'test';
}

let app;
if (!getApps().length) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApps()[0];
}

const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app, databaseId);

// Debug logging for Firestore db selection
if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'test') {
  // Only log on server (not browser) and not during tests
  // eslint-disable-next-line no-console
  console.log(`[Firestore] Using db: ${databaseId}`);
}

export { provider, auth, db, redirectURL }
